import { SubContent } from "../Layout";
import useFormatDate from "../../hooks/utils/useFormat";
import usePermission from "../../hooks/usePermission";
import useIsSystemAdmin from "../../hooks/useIsSystemAdmin";
import MenuItem from "../MenuItem";
import StatusFlag from "../StatusFlag";
import Tooltip2 from "../Tooltip";
import { NavLink } from "react-router-dom";
import IcFormando from "../Svg/IcFormando";
import IcFinanceiro from "../Svg/IcFinanceiro";
import IcBarCode from "../Svg/IcBarCode";
import IcBox from "../Svg/IcBox";
import IcVinculo from "../Svg/IcVinculo";
import IcAtendimento from "../Svg/IcAtendimento";
import IcConvite from "../Svg/IcConvite";

export default function TraineeSubMenu(props) {
  const { trainee } = props;
  const { formatPhone } = useFormatDate();
  const canReadFinancial = usePermission("trainee", "financialReading");
  const isSystemAdmin = useIsSystemAdmin();
  // a aba do Distrato só existe para quem tem um: "limitado" = multa em aberto,
  // "encerrado" = distrato já quitado (ou reembolso/sem movimentação). O
  // encerramento com acerto adiado ainda não tem distrato nenhum, mas precisa da
  // aba justamente para registrá-lo — é lá que fica o "Registrar Distrato".
  const hasDistrato =
    trainee?.access_status === "limitado" ||
    trainee?.access_status === "encerrado" ||
    trainee?.bond_status === "encerrado_aguardando_distrato";

  return (
    <>
      {!!trainee && (
        <>
          <SubContent className="mb-3">
            <h2 className="mini-title mb-1">{trainee?.name}</h2>
            <p className="m-0 small-label">
              <NavLink to={`/groups/${trainee?.commercial_id}/registrationdata`} target="_blank">
                <b>{trainee?.commercial_label}</b>
              </NavLink>
            </p>
            <p className="m-0 small-label">
              {formatPhone(trainee?.cell)}
              {!!trainee?.phone && <span className="ml-2">{formatPhone(trainee?.phone)}</span>}
            </p>
            <p className="m-0 small-label">{trainee.email}</p>

            <div className="divisor mt-2 mb-2"></div>
            <div className="d-flex flex-wrap align-items-center column-gap-3 row-gap-1">
              {!!trainee?.bond && (
                <span>
                  <span className="small-label mr-2">Vínculo:</span>
                  <StatusFlag status={trainee.bond} tone={trainee.bond_tone} />
                </span>
              )}
              {!!trainee?.aceite && (
                <span>
                  <span className="small-label mr-2">Aceite:</span>
                  <Tooltip2 tip={trainee.aceite_tip}>
                    <StatusFlag status={trainee.aceite} tone={trainee.aceite_tone} />
                  </Tooltip2>
                </span>
              )}
            </div>
            {/* Acesso é assunto do Administrador do Sistema. Para os demais
                gestores só o estado excepcional aparece: sem isto, o formando
                bloqueado reclamaria que não consegue entrar e o gestor não teria
                como descobrir o motivo em tela nenhuma. */}
            {isSystemAdmin ? (
              !!trainee?.access && (
                <div className="mt-1">
                  <span className="small-label mr-2">Acesso:</span>
                  <StatusFlag status={trainee.access} />
                </div>
              )
            ) : (
              !!trainee?.access_revoked && (
                <div className="mt-1">
                  <StatusFlag status="Acesso Revogado" tone="danger" />
                </div>
              )
            )}
          </SubContent>
          <SubContent className="p-0">
            <MenuItem icon={<IcFormando />} href={`/trainees/edit/${trainee?.id}`}>
              Dados do Formando
            </MenuItem>
            {canReadFinancial && (
              <>
                <MenuItem icon={<IcFinanceiro />} href={`/trainees/financial/${trainee?.id}`}>
                  Financeiro Contratado
                </MenuItem>
                <MenuItem icon={<IcBarCode />} href={`/trainees/charges/${trainee?.id}`}>
                  Cobranças Extras
                </MenuItem>
                <MenuItem icon={<IcBox />} href={`/trainees/products/${trainee?.id}`}>
                  Produtos Adquiridos
                </MenuItem>
                <MenuItem icon={<IcConvite />} href={`/trainees/invites/${trainee?.id}`}>
                  Convites e Ingressos
                </MenuItem>
                {hasDistrato && (
                  <MenuItem icon={<IcVinculo />} href={`/trainees/distrato/${trainee?.id}`}>
                    Distrato
                  </MenuItem>
                )}
              </>
            )}
            <MenuItem icon={<IcAtendimento />} href={`/trainees/attendance/${trainee?.id}`}>
              Atendimentos
            </MenuItem>
          </SubContent>
        </>
      )}
    </>
  );
}
